var map = {
	"./addressCard.svg": 8686,
	"./arrowLeft.svg": 8521,
	"./arrowRight.svg": 1389,
	"./danielFace.svg": 4178,
	"./envelope.svg": 8575,
	"./eventIcon.svg": 8958,
	"./eventLocationIcon.svg": 5132,
	"./facebook.svg": 5552,
	"./image.svg": 2030,
	"./instagram.svg": 8023,
	"./locationDot.svg": 7896,
	"./nav_addressCard.svg": 5691,
	"./nav_daniel.svg": 2177,
	"./nav_image.svg": 4974,
	"./nav_turntable.svg": 1253,
	"./paperPlane.svg": 4645,
	"./phone.svg": 3568,
	"./play.svg": 9990,
	"./turntable.svg": 1358,
	"./userIcon.svg": 5832,
	"./youtube.svg": 5990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2711;